import styled from 'styled-components/macro';

import {Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack} from "@chakra-ui/react";
import {useSaveFolders} from "../api/save";
import {useFeedback} from "../store/feedback";
import NavLink from "./nav_link";
import {themecolors} from "../utils/themecolors";
import {ChevronRight} from "lucide-react";

const Item = styled.div`
  display: flex;
  align-items: center;
  height: 52px;
  & svg {
    margin-right: 12px;
    margin-left: auto;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  &:hover svg {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  & span {
    cursor: pointer;
  }
`;
const Scroll = styled.div`
  max-height: 442px;
  overflow-y: auto;
`;

const SaveFolders = styled(({onClose}) => {
    const {feedbackCh} = useFeedback();
    const folders = useSaveFolders(feedbackCh);
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Your Save Folders</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <Scroll>
                            {folders?.map((folder, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <NavLink key={index} href={`/saved/${folder.name}`}>
                                    <Item>
                                        {`${folder.name} (${folder.count}) `}
                                        <ChevronRight size={18} />
                                    </Item>
                                </NavLink>
                            ))}
                        </Scroll>

                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )})``;

export default SaveFolders;
